import { Page, R } from '@/api/common-types'
import lcRequest from '@/api/request'
import {
  SysUserQueryDTO,
  CreateUserDTO,
  UpdateUserDTO,
  DeleteUserDTO,
  UpdateUserPasswordDTO,
  UserRoleAuthDTO,
  CheckUserNameUniqueDTO
} from '@/api/dto/user-dto'
import { UserInfoVO } from '@/api/vo/user-vo'

const MODULE_USER_URL = '/admin/user'

export function getUserPage(queryInfo: SysUserQueryDTO) {
  return lcRequest.post<R<Page<UserInfoVO>>>({
    url: MODULE_USER_URL + '/page',
    data: queryInfo
  })
}

export function addUser(userData: CreateUserDTO) {
  return lcRequest.post<R<boolean>>({
    url: MODULE_USER_URL + '/add',
    data: userData,
    showPrompt: true,
    showPromptSuccessMessage: '新增成功',
    showPromptErrorMessage: '新增失败'
  })
}

export function updateUser(userData: UpdateUserDTO) {
  return lcRequest.post<R<boolean>>({
    url: MODULE_USER_URL + '/edit',
    data: userData,
    showPrompt: true,
    showPromptSuccessMessage: '编辑成功',
    showPromptErrorMessage: '编辑失败'
  })
}

export function deleteUser(data: DeleteUserDTO) {
  return lcRequest.post<R<boolean>>({
    url: MODULE_USER_URL + '/remove',
    data
  })
}

export function getCurrentUserDetail() {
  return lcRequest.get<R<UserInfoVO>>({
    url: MODULE_USER_URL + '/userInfo'
  })
}

export function getUserDetail(userId: number) {
  return lcRequest.get<R<UserInfoVO>>({
    url: MODULE_USER_URL + '/view/' + userId
  })
}

export function updateUserPassword(data: UpdateUserPasswordDTO) {
  return lcRequest.post<R<boolean>>({
    url: MODULE_USER_URL + '/password/update',
    data,
    showPrompt: true,
    showPromptSuccessMessage: '修改成功',
    showPromptErrorMessage: '修改失败'
  })
}

export function changeUserStatus(userId: number, status: number) {
  return lcRequest.post<R<boolean>>({
    url: MODULE_USER_URL + '/changeStatus',
    params: { userId, status }
  })
}

export function authUserRole(data: UserRoleAuthDTO) {
  return lcRequest.post<R<boolean>>({
    url: MODULE_USER_URL + '/authRole/insertAuthRole',
    data
  })
}

export function checkUserNameUnique(data: CheckUserNameUniqueDTO) {
  return lcRequest.post<R<boolean>>({
    url: MODULE_USER_URL + '/checkUserNameUnique',
    data
  })
}
